import React from 'react';
import { reduxForm } from 'redux-form';
import _ from 'lodash';
import { EXPORT_SSO_FORM } from 'src/constants/FormNames';
import Button from 'jbc-front/components/Button';
import CommonModal from 'jbc-front/components/CommonModal';
import { ErrorsSection } from 'src/components';
import { FormSubmitBtn } from 'src/buttons';
import styles from './ExportSsoModal.scss';
import { useTranslation } from 'react-i18next';
import { RadioField } from 'src/jbc-front/components/Form';
import { SSO_OPTIONS } from 'src/constants/Options';

const ExportSsoInsideForm = ({
  errors,
  submitting,
  submit,
  isOpen,
  hideModal,
  paymentRange,
  onModalHide
}) => {
  const { t } = useTranslation();
  const yearMonth = _.get(paymentRange, 'yearMonth', '_').split('_');
  const header = `${t('features.EmployeePays.components.ExportSsoModal.Data_Export_for_Social_Security_Submission')}　＜${yearMonth[1]}/${yearMonth[0]}＞`;
  return (
    <CommonModal ariaHideApp={false} {...{ isOpen, hideModal, onModalHide }}>
      <CommonModal.Header hideModal={hideModal}>{header}</CommonModal.Header>
      <CommonModal.Body>
        <form className={styles.form}>
          <p className="u-mb40">{t('features.EmployeePays.components.ExportSsoModal.Export_data_required_for_social_security_submission_into_excel_file')}</p>
          <ErrorsSection errors={errors} />
        </form>
      </CommonModal.Body>
      <CommonModal.Footer>
        <Button onClick={hideModal} className="u-mr20">
          {t('features.EmployeePays.components.ExportPndModal.Cancel')}
        </Button>
        <FormSubmitBtn text={t('features.EmployeePays.components.ExportPndModal.Export')} {...{submitting, submit }} />
      </CommonModal.Footer>
    </CommonModal>
  );
};

const ExportSsoForm = reduxForm({
  form: EXPORT_SSO_FORM
})(ExportSsoInsideForm);

const ExportSsoModal = ({ paymentRange, errors, onModalHide, handleSubmit, isOpen, hideModal }) => (
  <ExportSsoForm
    isOpen={isOpen}
    hideModal={hideModal}
    onSubmit={values => handleSubmit(values, paymentRange)}
    paymentRange={paymentRange}
    errors={errors}
    onModalHide={onModalHide}
  />
);

export default ExportSsoModal;